import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import Home from './pages/Home';
import Products from './pages/Products';
import Admin from './pages/Admin';
import Checkout from './pages/Checkout';
import OrderSuccess from './pages/OrderSuccess';
import OrderFail from './pages/OrderFail';

function SiteLayout({ children }) {
  return (
    <div className="bg-bg-primary text-white overflow-x-hidden">
      <Navbar />
      {children}
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default function App() {
  return (
    <CartProvider>
      <Router>
        <Routes>
          <Route path="/" element={<SiteLayout><Home /></SiteLayout>} />
          <Route path="/urunler" element={<SiteLayout><Products /></SiteLayout>} />
          <Route path="/odeme" element={<SiteLayout><Checkout /></SiteLayout>} />
          <Route path="/odeme-basarili" element={<SiteLayout><OrderSuccess /></SiteLayout>} />
          <Route path="/odeme-basarisiz" element={<SiteLayout><OrderFail /></SiteLayout>} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </Router>
    </CartProvider>
  );
}
